/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type UseQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useQueryResultOnSuccess<T>(
  queryResult: UseQueryResult<T, Error>,
  onSuccess: ((data: T) => void) | undefined
) {
  useEffect(() => {
    if (queryResult.isSuccess) {
      onSuccess?.(queryResult.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryResult.isSuccess, queryResult.data]);
}
